import React from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'
import { Card, CardContent } from '@/shared/components/molecules/Card/Card'

/**
 * Error state component for users list
 */
export const UsersError: React.FC = () => {
	const { t } = useTranslation('common')

	return (
		<div className="space-y-6">
			<Card>
				<CardContent className="p-6">
					<div className="text-center text-destructive">
						{t('account.user_profile.account.error_loading') ||
							'Error loading users. Please try again.'}
					</div>
				</CardContent>
			</Card>
		</div>
	)
}
